import FJUtil from './FJUtil';

const FJVideoUtil = {
    /**
     * @description 返回解码视频帧类型
     * @returns
     */
    getDecodeVideoFrameType: function () {
        if (FJUtil.getBrowser() === 'FF') {
            return 'IMAGEBITMAP';
        }

        if (FJUtil.couldUseWebCodecs('decode') && typeof VideoFrame !== 'undefined') {
            return 'VIDEOFRAME';
        }
        if (
            typeof ImageBitmap !== 'undefined' &&
            typeof createImageBitmap !== 'undefined' &&
            typeof OffscreenCanvas !== 'undefined'
        ) {
            return 'IMAGEBITMAP';
        }
        return 'TYPEDARRAY';
    },

    /**
     * @description 加载视频
     * @param {File} file
     * @returns
     */
    loadVideo: function (file) {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            video.src = URL.createObjectURL(file);

            video.onloadedmetadata = () => {
                resolve({
                    width: video.videoWidth,
                    height: video.videoHeight,
                    duration: video.duration,
                    src: video.src,
                    name: file.name,
                });
            };
            video.onerror = () => {
                reject(new Error('Failed to load video'));
            };
        });
    },
};

export default FJVideoUtil;
